module.exports = __webpack_public_path__ + "front/img/kv05.f353113b.png";